import axios from "axios";
import authHeader from "@/services/auth-header";
import config from "@/data/config";

const API_URL = config.baseURL;

export const service = {
   namespaced: true,
   state: {
      lingkunganStasi: [],
      wilayah: [],
      hirarki: {},
   },
   getters: {},
   actions: {
      getUmat({ rootState }, data) {
         rootState.isLoading = true;
         return axios
            .post(`${API_URL}service/umat`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },      
      getKK({ rootState }, data) {
         rootState.isLoading = true;
         return axios
            .post(`${API_URL}service/kk`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      getLingkunganStasi({ commit, state, rootState }) {
         if (!state.lingkunganStasi.length) {
            rootState.isLoading = true;
            axios
               .get(`${API_URL}service/lingkungan_stasi`, {
                  headers: authHeader(),
               })
               .then(
                  (response) => {
                     commit("SET_LINGKUNGAN_STASI", response.data);
                     rootState.isLoading = false;
                  },
                  () => {
                     rootState.isLoading = false;
                  }
               );
         }
      },
      getWilayah({ commit, rootState }) {
         rootState.isLoading = true;
         axios
            .get(`${API_URL}service/wilayah`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_WILAYAH", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      getHirarki({ commit, rootState }) {
         rootState.isLoading = true;
         axios
            .get(`${API_URL}service/hirarki`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_HIRARKI", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      resetService({ commit, rootState }) {
         // window.localStorage.removeItem('vuex');
         rootState.isLoading = true;
         axios
            .get(`${API_URL}service/hirarki`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_HIRARKI", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
   },
   mutations: {
      SET_LINGKUNGAN_STASI(state, data) {
         state.lingkunganStasi = data;
      },
      SET_WILAYAH(state, data) {
         state.wilayah = data;
      },
      SET_HIRARKI(state, data) {
         state.hirarki = data;
      },
   },
};
